/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const fr_previous_tech_collaborations_lacked_business_impact = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vos précédentes collaborations tech n'ont pas généré l'impact business attendu.`)
};

const en_previous_tech_collaborations_lacked_business_impact = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your previous tech collaborations didn't generate the expected business impact.`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const previous_tech_collaborations_lacked_business_impact = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.previous_tech_collaborations_lacked_business_impact(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("previous_tech_collaborations_lacked_business_impact", locale)
	if (locale === "fr") return fr_previous_tech_collaborations_lacked_business_impact(inputs)
	return en_previous_tech_collaborations_lacked_business_impact(inputs)
};